import { PencilSimpleLine } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { IPartFinderAttribute } from 'companySettings/types';
import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { Variant } from 'theme/enums';

import { UpsertPartFinderAttributeButton } from '../UpsertPartFinderAttribute';

// The drawer edits one list, so the button needs exactly one selected row.
export const EditPartFinderAttributeButton = () => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridClientTableContext();

  const attribute =
    1 === selectedRows?.length ? (selectedRows[0] as IPartFinderAttribute) : undefined;

  return (
    <UpsertPartFinderAttributeButton
      attribute={attribute}
      buttonElement={
        <Button
          text={t('buttonLabelEdit')}
          variant={Variant.OUTLINED}
          startDecorator={<PencilSimpleLine />}
          disabled={!attribute}
        />
      }
    />
  );
};
